// extracted by mini-css-extract-plugin
module.exports = {"banners-slider":"bannersCarousel__banners-slider___39SHg"};